export const iconFontAwesomeEnergyLightbulb = (
	<i className="fa-solid fa-lightbulb"></i>
);
